/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import {
  AD_FRAMEWORK_TYPE,
  API_TYPE,
  APPLICATION_TYPE,
  MEDIAPLAYER_TYPE,
} from "../../app/Constants/Constants";
import { types } from "./actions";

const initialState = {
  list: [],
  successResponse: null,
  createSuccessResponse: null,
  errorResponse: null,
  adFramework: null,
  mediaPlayer: null,
  error: null,
  loading: false,
  loaded: false,
  logs: [],
  collectorMgmtDetails: null,
  collectorMgmtLoading: false,
  collectorMgmtLoaded: false,
  createJiraSuccessResponse: null,
  createJiraErrorResponse: null,
  isloading: false,
  isloaded: false,
  collectorLogLoading: false,
  collectorLogLoaded: false,
  supportedDataPoints: [],
  totalDataPoints: null,
  supportedDataPointsLoading: false,
  supportedDataPointsLoaded: false,
  supportedDataPointsListError: null,
  supportedDataPointsOverlay: [],
  totalDataPointsOverlay: null,
  supportedDataPointsLoadingOverlay: false,
  supportedDataPointsLoadedOverlay: false,
  supportedDataPointsListErrorOverlay: null,
  supportedDataPointSuccessResponse: null,
  supportedDataPointFailedResponse: null,
  datapointsPlatformName: null,
  datapointsCollectorName: null,
  datapointsMediaPlayerName: null,
  datapointsAdFrameworkName: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.COLLECTOR_MANAGEMENT_LIST:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case types.COLLECTOR_MANAGEMENT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.payload,
      };
    case types.COLLECTOR_MANAGEMENT_LIST_FAILED:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    case types.CLEAR_COLLECTOR_MANAGEMENT_LIST:
      return {
        ...initialState,
      };
    case types.FETCH_A_COLLECTOR_MANAGEMENT:
      return {
        ...state,
        collectorMgmtLoading: true,
        collectorMgmtLoaded: false,
      };

    case types.FETCH_A_COLLECTOR_MANAGEMENT_SUCCESS: {
      const { data, additionalInfo } = action.payload;
      let collector = { ...state.collectorMgmtDetails };
      const commonProps = {
        type: additionalInfo?.type,
        id: additionalInfo?.id,
        name: data?.collectorName || data?.name,
        key: data?.collectorKey || data?.key,
        status: data?.status,
        collectorImage: data?.collectorImage,
        visibility: data?.visibility,
      };
      /* istanbul ignore if */
      if (additionalInfo?.type === APPLICATION_TYPE) {
        collector = {
          application: {
            ...commonProps,
            supportedMediaPlayers: data?.supportedMediaPlayers || [],
            supportedAdFrameworks: data?.supportedAdFrameworks || [],
            supportSampling: data?.supportSampling,
            supportAppSessionTimeOut: data?.supportAppSessionTimeOut,
            jiraIntegrationStatus: data?.jiraIntegrationStatus,
            supportCmcd: data?.supportCmcd,
            collectorName: data?.collectorName,
          },
        };
        delete collector.mediaPlayer;
        delete collector.adFramework;
      }
      /* istanbul ignore if */
      if (additionalInfo?.type === MEDIAPLAYER_TYPE) {
        const queryData = additionalInfo?.queryData;
        if (queryData) {
          collector.application = {};
        }
        const application =
          Object.keys(collector.application || {}).length === 0 && queryData
            ? queryData?.collector
            : { ...collector.application };
        collector = {
          ...collector,
          application,
          mediaPlayer: {
            ...commonProps,
            supportSampling: data?.supportSampling,
            supportAppSessionTimeOut: data?.supportAppSessionTimeOut,
            jiraIntegrationStatus: data?.jiraIntegrationStatus,
            supportCmcd: data?.supportCmcd,
            currentVersion: data?.currentVersion,
            supportedAdFrameworks: data?.supportedAdFrameworks || [],
            mediaPlayerName: data?.collectorName || data?.name,
          },
        };
        delete collector.adFramework;
      }
      /* istanbul ignore if */
      if (additionalInfo?.type === AD_FRAMEWORK_TYPE) {
        const queryData = additionalInfo?.queryData;
        if (queryData) {
          collector.application = {};
        }
        const application =
          Object.keys(collector.application || {}).length === 0 && queryData
            ? queryData?.collector
            : { ...collector.application };
        collector = {
          ...collector,
          application,
          adFramework: {
            ...commonProps,
            jiraIntegrationStatus: data?.jiraTicketsCreated,
            supportedAdFrameworks: data?.supportedAdFrameworks || [],
            mediaPlayerName:
              queryData?.mediaPlayerName ||
              collector?.mediaPlayer?.name ||
              collector?.adFramework?.mediaPlayerName,
            mediaPlayerId:
              queryData?.mediaPlayerId ||
              collector?.mediaPlayer?.id ||
              collector?.adFramework?.mediaPlayerId,
          },
        };
        delete collector.mediaPlayer;
      }
      /* istanbul ignore if */
      if (additionalInfo?.type === API_TYPE) {
        collector = {
          api: {
            ...commonProps,
            supportSampling: data?.supportSampling,
            supportAppSessionTimeOut: data?.supportAppSessionTimeOut,
            jiraIntegrationStatus: data?.jiraIntegrationStatus,
            supportCmcd: data?.supportCmcd,
          },
        };
      }
      return {
        ...state,
        collectorMgmtLoading: false,
        collectorMgmtLoaded: true,
        collectorMgmtDetails: collector,
      };
    }
    case types.FETCH_A_COLLECTOR_MANAGEMENT_FAILED: {
      return {
        ...state,
        collectorMgmtLoading: false,
        collectorMgmtLoaded: true,
        error: action.payload,
      };
    }
    case types.CREATE_COLLECTOR_MANAGEMENT_JIRA: {
      return {
        ...state,
        isloading: true,
        isloaded: false,
        createJiraSuccessResponse: null,
        createJiraErrorResponse: null,
      };
    }
    case types.CREATE_COLLECTOR_MANAGEMENT_JIRA_SUCCESS: {
      return {
        ...state,
        isloading: false,
        isloaded: true,
        createJiraSuccessResponse: action.payload,
      };
    }
    case types.CREATE_COLLECTOR_MANAGEMENT_JIRA_FAILED: {
      return {
        ...state,
        isloading: false,
        isloaded: true,
        createJiraErrorResponse: action.payload,
      };
    }
    case types.CLEAR_COLLECTOR_MANAGEMENT_DETAILS:
      return {
        ...state,
        collectorMgmtDetails: null,
        collectorMgmtLoading: false,
        collectorMgmtLoaded: false,
        error: null,
      };
    case types.CREATE_COLLECTOR: {
      return {
        ...state,
        isloading: true,
        isloaded: false,
      };
    }
    case types.CREATE_COLLECTOR_SUCCESS: {
      return {
        ...state,
        isloading: false,
        isloaded: true,
        createSuccessResponse: action.payload,
      };
    }
    case types.CREATE_COLLECTOR_FAILED: {
      return {
        ...state,
        isloading: false,
        isloaded: true,
        errorResponse: action.payload,
      };
    }
    case types.CLEAR_CREATE_COLLECTOR_FAILED_RESPONSE: {
      return {
        ...state,
        errorResponse: null,
      };
    }
    case types.UPDATE_COLLECTOR_MANAGEMENT:
      return {
        ...state,
        isloading: true,
        isloaded: false,
        successResponse: null,
        error: null,
      };
    case types.UPDATE_COLLECTOR_MANAGEMENT_SUCCESS:
      return {
        ...state,
        isloading: false,
        isloaded: true,
        successResponse: action.payload,
      };
    case types.UPDATE_COLLECTOR_MANAGEMENT_FAILED:
      return {
        ...state,
        isloading: false,
        isloaded: true,
        error: action.payload,
      };
    case types.FETCH_A_COLLECTOR_LOGS: {
      return {
        ...state,
        collectorLogLoading: true,
        collectorLogLoaded: false,
        logs: action.payload,
      };
    }
    case types.FETCH_A_COLLECTOR_LOGS_SUCCESS: {
      return {
        ...state,
        collectorLogLoading: false,
        collectorLogLoaded: true,
        logs: action.payload,
      };
    }
    case types.FETCH_A_COLLECTOR_LOGS_FAILED: {
      return {
        ...state,
        collectorLogLoading: false,
        collectorLogLoaded: true,
        error: action.payload,
      };
    }
    case types.CREATE_AD_FRAMEWORK: {
      return {
        ...state,
        isloading: true,
        isloaded: false,
      };
    }
    case types.CREATE_AD_FRAMEWORK_SUCCESS: {
      return {
        ...state,
        isloading: false,
        isloaded: true,
        adFramework: action.payload,
      };
    }
    case types.CREATE_AD_FRAMEWORK_FAILED: {
      return {
        ...state,
        isloading: false,
        isloaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_SUPPORTED_DATA_POINTS: {
      return {
        ...state,
        supportedDataPoints: [],
        totalDataPoints: null,
        supportedDataPointsLoading: true,
        supportedDataPointsLoaded: false,
        datapointsPlatformName: null,
        datapointsCollectorName: null,
        datapointsMediaPlayerName: null,
        datapointsAdFrameworkName: null,
      };
    }
    case types.FETCH_SUPPORTED_DATA_POINTS_SUCCESS: {
      return {
        ...state,
        supportedDataPoints: action.payload?.dataPoints,
        totalDataPoints: action?.payload?.total,
        supportedDataPointsLoading: false,
        supportedDataPointsLoaded: true,
        datapointsPlatformName: action.payload.platform,
        datapointsCollectorName: action.payload.collectorName,
        datapointsMediaPlayerName: action.payload.mediaPlayer,
        datapointsAdFrameworkName: action.payload.adFramework,
      };
    }
    case types.FETCH_SUPPORTED_DATA_POINTS_FAILED: {
      return {
        ...state,
        supportedDataPoints: [],
        supportedDataPointsListError: action.payload,
        supportedDataPointsLoading: false,
        supportedDataPointsLoaded: true,
        datapointsPlatformName: null,
        datapointsCollectorName: null,
        datapointsMediaPlayerName: null,
        datapointsAdFrameworkName: null,
      };
    }
    case types.FETCH_MORE_SUPPORTED_DATA_POINTS: {
      return {
        ...state,
      };
    }
    case types.FETCH__MORE_SUPPORTED_DATA_POINTS_SUCCESS: {
      return {
        ...state,
        supportedDataPoints: [
          ...(state.supportedDataPoints || []),
          ...(action.payload?.dataPoints || []),
        ],
      };
    }
    case types.FETCH__MORE_SUPPORTED_DATA_POINTS_FAILED: {
      return {
        ...state,
        supportedDataPoints: [],
        MediaPlayerListError: action.payload,
      };
    }
    case types.CLEAR_SUPPORTED_DATA_POINTS: {
      return {
        ...state,
        supportedDataPoints: [],
        supportedDataPointsLoading: false,
        supportedDataPointsLoaded: false,
        supportedDataPointsListError: null,
      };
    }
    case types.CREATE_MEDIAPLAYER: {
      return {
        ...state,
        isloading: true,
        isloaded: false,
      };
    }
    case types.CREATE_MEDIAPLAYER_SUCCESS: {
      return {
        ...state,
        isloading: false,
        isloaded: true,
        mediaPlayer: action.payload,
      };
    }
    case types.CREATE_MEDIAPLAYER_FAILED: {
      return {
        ...state,
        isloading: false,
        isloaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_SUPPORTED_DATA_POINTS_OVERLAY: {
      return {
        ...state,
        supportedDataPointsOverlay: [],
        totalDataPointsOverlay: null,
        supportedDataPointsLoadingOverlay: true,
        supportedDataPointsLoadedOverlay: false,
      };
    }
    case types.FETCH_SUPPORTED_DATA_POINTS_SUCCESS_OVERLAY: {
      return {
        ...state,
        supportedDataPointsOverlay: action.payload?.dataPoints,
        totalDataPointsOverlay: action?.payload?.total,
        supportedDataPointsLoadingOverlay: false,
        supportedDataPointsLoadedOverlay: true,
      };
    }
    case types.FETCH_SUPPORTED_DATA_POINTS_FAILED_OVERLAY: {
      return {
        ...state,
        supportedDataPointsOverlay: [],
        supportedDataPointsListErrorOverlay: action.payload,
        supportedDataPointsLoadingOverlay: false,
        supportedDataPointsLoadedOverlay: true,
      };
    }
    case types.FETCH_MORE_SUPPORTED_DATA_POINTS_OVERLAY: {
      return {
        ...state,
      };
    }
    case types.FETCH__MORE_SUPPORTED_DATA_POINTS_SUCCESS_OVERLAY: {
      return {
        ...state,
        supportedDataPointsOverlay: [
          ...(state.supportedDataPointsOverlay || []),
          ...(action.payload?.dataPoints || []),
        ],
      };
    }
    case types.FETCH__MORE_SUPPORTED_DATA_POINTS_FAILED_OVERLAY: {
      return {
        ...state,
        supportedDataPointsOverlay: [],
        MediaPlayerListErrorOverlay: action.payload,
      };
    }
    case types.CLEAR_SUPPORTED_DATA_POINTS_OVERLAY: {
      return {
        ...state,
        supportedDataPointsOverlay: [],
        supportedDataPointsLoadingOverlay: false,
        supportedDataPointsLoadedOverlay: false,
        supportedDataPointsListErrorOverlay: null,
      };
    }
    case types.AUTHORED_UNAUTHORED_DATAPOINT: {
      return {
        ...state,
        supportedDataPointSuccessResponse: null,
        supportedDataPointFailedResponse: null,
      };
    }
    case types.AUTHORED_UNAUTHORED_DATAPOINT_SUCCESS: {
      return {
        ...state,
        supportedDataPointSuccessResponse: action.payload,
        supportedDataPointFailedResponse: null,
      };
    }
    case types.AUTHORED_UNAUTHORED_DATAPOINT_FAILED: {
      return {
        ...state,
        supportedDataPointSuccessResponse: null,
        supportedDataPointFailedResponse: action.payload,
      };
    }
    case types.CLEAR_AUTHORED_UNAUTHORED_DATAPOINT_MESSAGES: {
      return {
        ...state,
        supportedDataPointSuccessResponse: null,
        supportedDataPointFailedResponse: null,
      };
    }
    default:
      return state;
  }
}
